<div class="main-container">
    <div id="sign-in-ui-container">
        <alert code="{{code}}" message="{{message}}"></alert>
        <template #ciapContainer></template>
    </div>
</div>